var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-20"},[_c('h2',{staticClass:"text-xl"},[_vm._v("จัดการข้อมูลหน่วยงาน")]),_c('v-tabs',[_c('v-tab',[_vm._v(" EIT ข้อมูลผู้มีส่วนได้ส่วนเสียภายนอก ")]),_c('v-tab-item',[_c('AgencyEitUser')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }